import UI from '@ui-system/ui';
import React from 'react';

export const DatePickerIcon: React.FC = () => (
  <UI.Icon name="calendar" size={20} color="primary" />
);
